// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2loYZ","name":"ConsentHeader_name__3lW6d","birthday":"ConsentHeader_birthday__3W9VV","skeleton":"ConsentHeader_skeleton__SPG3d"};